import React from 'react';

export default function useClipboard() {
    const [snackBarState, setSnackBarState] = React.useState<{
        open: boolean;
        text: string;
    }>({
        open: false,
        text: ''
    });

    const copyToClipboard = async (text: string) => {
        if (!text) return;

        try {
            if (window.isSecureContext) {
                await navigator.clipboard.writeText(text);

                setSnackBarState({
                    open: true,
                    text: 'Copied to clipboard'
                });
            } else {
                setSnackBarState({
                    open: true,
                    text: 'Could not copy'
                });
            }
        } catch {
            setSnackBarState({
                open: true,
                text: 'Could not copy'
            });
        }
    };

    const handleClose = () => {
        setSnackBarState((prev) => ({
            ...prev,
            open: false
        }));
    };

    return {
        snackBarState,
        copyToClipboard,
        handleClose
    };
}